import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import AuthPage from './components/AuthPage';
import HomePage from './components/HomePage';
import ActivitiesPage from './components/ActivitiesPage';
import ProfilePage from './components/ProfilePage';
import Navigation from './components/Navigation';
import './App.css';

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [userData, setUserData] = useState(null);

  useEffect(() => {
    checkAuthStatus();
  }, []);

  const checkAuthStatus = () => {
    const token = localStorage.getItem('userToken');
    const storedUserData = localStorage.getItem('userData');
    
    if (token && storedUserData) {
      setIsAuthenticated(true);
      setUserData(JSON.parse(storedUserData));
    }
    setIsLoading(false);
  };

  const handleLogin = (userData) => {
    localStorage.setItem('userToken', 'dummy-token-' + Date.now());
    localStorage.setItem('userData', JSON.stringify(userData));
    setUserData(userData);
    setIsAuthenticated(true);
  };

  const handleLogout = () => {
    localStorage.removeItem('userToken');
    localStorage.removeItem('userData');
    setUserData(null);
    setIsAuthenticated(false);
  };

  if (isLoading) {
    return (
      <div className="loading-container">
        <div className="spinner"></div>
        <p>Loading Brain Rot...</p>
      </div>
    );
  }

  return (
    <Router>
      <div className="app">
        {isAuthenticated ? (
          <>
            <Navigation onLogout={handleLogout} userData={userData} />
            <div className="main-content">
              <Routes>
                <Route path="/" element={<HomePage userData={userData} />} />
                <Route path="/activities" element={<ActivitiesPage />} />
                <Route path="/profile" element={<ProfilePage userData={userData} onLogout={handleLogout} />} />
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </div>
          </>
        ) : (
          <Routes>
            <Route path="*" element={<AuthPage onLogin={handleLogin} />} />
          </Routes>
        )}
      </div>
    </Router>
  );
}

export default App;